var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgGamificationDefault = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 217,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "gamification-default_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 389,
    height: 217
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h389v217H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gamification-default_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.284 1.231H32.717c-6.13 0-12.008 2.4-16.342 6.673-4.335 4.273-6.77 10.068-6.77 16.11v273.389c0 6.042 2.435 11.837 6.77 16.109 4.334 4.273 10.213 6.673 16.342 6.673h323.567c6.129 0 12.008-2.4 16.342-6.673 4.335-4.272 6.77-10.067 6.77-16.109V24.013c0-6.041-2.435-11.836-6.77-16.109-4.334-4.272-10.213-6.673-16.342-6.673ZM89.573 46.796c6.856 0 13.559 2.005 19.26 5.76a34.278 34.278 0 0 1 12.768 15.336 33.718 33.718 0 0 1 1.973 19.745 34.015 34.015 0 0 1-9.488 17.497 34.82 34.82 0 0 1-17.75 9.353 35.135 35.135 0 0 1-20.03-1.945 34.56 34.56 0 0 1-15.559-12.586 33.828 33.828 0 0 1-5.842-18.986c0-9.064 3.652-17.756 10.154-24.164 6.501-6.41 15.32-10.01 24.514-10.01ZM55.829 263.23v-46.704l69.336-69.258a11.64 11.64 0 0 1 8.147-3.313 11.64 11.64 0 0 1 8.147 3.313l29.93 28.819-88.75 87.143h-26.81Zm277.343 0h-217.83l71.994-70.967 62.402-61.513a11.644 11.644 0 0 1 8.147-3.312c3.053 0 5.982 1.191 8.147 3.312l67.14 66.183v66.297Z",
    fill: "#F7F7F7"
  }))));
};
export { SvgGamificationDefault as ReactComponent };
export default __webpack_public_path__ + "34d1b272f702cbb9a709ebf51dd00761.svg";